import axios from 'axios'

// 直接使用Ollama服务URL
const OLLAMA_DIRECT_URL = 'http://localhost:8000/api/generate'

export const generateResponse = async (prompt, options = {}) => {
  try {
    console.log('发送请求到 Ollama API:', prompt)

    // 尝试直接连接Ollama服务而不使用代理
    const response = await axios.post(OLLAMA_DIRECT_URL, {
      model: 'deepseek-r1:1.5b', // 使用您已下载的模型名称
      prompt: prompt,
      stream: false,
      ...options
    }, {
      withCredentials: false, // 必须设置为false
      headers: {
        'Content-Type': 'application/json'
      }
    })

    console.log('收到 Ollama 响应:', response.data)
    return response.data
  } catch (error) {
    // 处理跨域问题，如果直接连接失败，尝试再次使用代理
    if (error.message && error.message.includes('Network Error')) {
      console.warn('直接连接Ollama失败，尝试通过代理连接...')
      try {
        // 通过代理连接
        const proxyResponse = await axios.post('/ollama-api/generate', {
          model: 'deepseek-r1:1.5b',
          prompt: prompt,
          stream: false,
          ...options
        }, {
          withCredentials: false,
          headers: {
            'Content-Type': 'application/json'
          }
        })

        console.log('通过代理收到Ollama响应:', proxyResponse.data)
        return proxyResponse.data
      } catch (proxyError) {
        console.error('通过代理连接Ollama也失败:', proxyError)
        throw proxyError
      }
    }

    // 原有错误处理代码
    console.error('调用本地Ollama API出错:', error)

    // 详细记录错误信息以便调试
    if (error.response) {
      // 服务器响应了，但状态码不在 2xx 范围内
      console.error('错误状态码:', error.response.status)
      console.error('错误信息:', error.response.data)
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      console.error('没有收到响应:', error.request)
    } else {
      // 设置请求时发生错误
      console.error('请求错误:', error.message)
    }

    throw error
  }
}

/**
 * 检查Ollama服务是否可用
 * @returns {Promise<boolean>} 服务是否在线
 */
export const checkOllamaService = async () => {
  try {
    // 直接连接Ollama服务
    const response = await axios.get('http://localhost:8000/api/list', {
      timeout: 5000,
      withCredentials: false
    })

    console.log('Ollama服务检查结果:', response.status, response.data)
    return true
  } catch (error) {
    console.error('直接连接Ollama服务失败:', error.message)

    // 尝试通过代理检查
    try {
      const proxyResponse = await axios.post('/ollama-api/generate', {
        model: 'deepseek-r1:1.5b',
        prompt: 'test',
        stream: false
      }, {
        timeout: 3000,
        withCredentials: false
      })

      console.log('代理检查成功')
      return true
    } catch (proxyError) {
      console.error('代理检查也失败:', proxyError.message)
      return false
    }
  }
}

// 使用环境变量或代理路径
const OLLAMA_API_URL = process.env.NODE_ENV === 'development'
  ? '/ollama-api/generate' // 使用代理
  : '/ollama-api/generate' // 生产环境使用相对路径

// 修改API调用
export async function getModelList() {
  try {
    const response = await axios.get('/ollama-api/list', {
      timeout: 5000
    })
    return response.data
  } catch (error) {
    console.error('获取模型列表失败:', error)
    throw error
  }
}
